import { FC, PropsWithChildren, useContext } from 'react';

import { $DrawerFooter } from './DrawerFooter.styles';
import { SwipeableDrawerContext } from './SwipeableDrawer.context';

export const DrawerFooter: FC<PropsWithChildren> = ({ children }) => {
  const { hasPadding } = useContext(SwipeableDrawerContext);

  return <$DrawerFooter $hasPadding={hasPadding}>{children}</$DrawerFooter>;
};
